const ITEMS = [
  {
    icon: "ri-stack-line",
    badge: "01",
    title: "Roll Press Hydraulic Control",
    desc: "롤프레스 장비의 압력, 위치, 갭 제어를 위한 서보유압 시스템 구성",
    color: "primary",
  },
  {
    icon: "ri-equalizer-line",
    badge: "02",
    title: "Servo / Proportional Valve",
    desc: "서보밸브 및 비례밸브를 이용한 유압 실린더 정밀 제어",
    color: "accent",
  },
  {
    icon: "ri-cpu-line",
    badge: "03",
    title: "Motion Controller & Drive",
    desc: "MSC III, PLC, EtherCAT, Analog/Digital I/O 기반 모션제어 시스템",
    color: "secondary",
  },
  {
    icon: "ri-radar-line",
    badge: "04",
    title: "Sensor Feedback & Commissioning",
    desc: "위치/압력 센서 피드백 기반 폐루프 제어 및 현장 시운전 지원",
    color: "primary",
  },
];

function colorClasses(c: string) {
  switch (c) {
    case "accent":
      return {
        iconBg: "bg-accent-100",
        iconText: "text-accent-700",
        badge: "text-accent-700",
        ring: "group-hover:border-accent-300",
      };
    case "secondary":
      return {
        iconBg: "bg-secondary-100",
        iconText: "text-secondary-800",
        badge: "text-secondary-700",
        ring: "group-hover:border-secondary-300",
      };
    default:
      return {
        iconBg: "bg-primary-100",
        iconText: "text-primary-700",
        badge: "text-primary-700",
        ring: "group-hover:border-primary-300",
      };
  }
}

export default function CoreBusinessSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-accent-700 mb-3">
              <span className="w-6 h-px bg-accent-500" />
              Our Core Business
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950 leading-tight">
              MC TECH가 제공하는{" "}
              <span className="text-primary-700">정밀 제어 솔루션</span>
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              단순 제품 공급을 넘어, 장비 한 대 한 대를 위한 제어 시스템을
              설계·구성·시운전까지 책임집니다.
            </p>
          </div>
          <div className="hidden md:flex items-center gap-2 text-xs font-medium text-secondary-600">
            <i className="ri-shield-star-line w-4 h-4 flex items-center justify-center" />
            <span>MOOG 제품 공급 및 기술지원</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((it) => {
            const cc = colorClasses(it.color);
            return (
              <div
                key={it.title}
                className={`group bg-background-100 border border-background-200 rounded-xl p-6 transition-all hover:bg-background-50 ${cc.ring}`}
              >
                <div className="flex items-center justify-between mb-5">
                  <div
                    className={`w-12 h-12 rounded-lg flex items-center justify-center ${cc.iconBg} ${cc.iconText}`}
                  >
                    <i className={`${it.icon} text-2xl w-6 h-6 flex items-center justify-center`} />
                  </div>
                  <span
                    className={`text-xs font-heading font-extrabold tracking-wider ${cc.badge}`}
                  >
                    {it.badge}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 leading-snug">
                  {it.title}
                </h3>
                <p className="mt-2.5 text-sm md:text-base text-foreground-700 leading-relaxed">
                  {it.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}